import React from "react";
// import { Switch, Route, withRouter } from 'react-router-dom';
import {BrowserRouter, Switch, Route, Redirect} from 'react-router-dom'
import Home from './components/Pages/Home/Home';
// import Produto_Cards from './components/Produtos_Cards/Produtos_Cards';
import Lojas_Fisicas from './components/Pages/Lojas_Localizacoes/Lojas_Localizacoes';
import Entregas from './components/Pages/FreteGratis/FreteGratis';
import Privacidade from './components/Pages/Privacidade/Privacidade';
import Produtos from './components/Pages/Produtos/Produtos';
import Login from './components/Pages/LoginTela/LoginTela';
import Logout from './components/Pages/LoginTela/LogoutTela';
import ComoPesquisarProdutos from './components/Pages/ComoPesquisarProdutos/ComoPesquisarProdutos';
import MeuCarrinho from './components/Pages/MeuCarrinho/MeuCarrinho';
// import Cadastro from './components/Pages/Cadastro/Cadastro';  // Cadastro Usuários
import MinhaConta from './components/Pages/MinhaConta/Minha_Conta'; // Minha Conta
// import MinhaContaDash from './components/Pages/Cadastro/DashCadastro'; // Minha Conta Dash
import ComprasFaturadas from './components/Pages/Faturado/Faturado';  // Compras Faturadas
import Meu_Pedido from './components/Pages/Meu_Pedido/Meu_Pedido';  // Meu Pedido (Pedido Efetuado)
import Meus_Pedidos from './components/Pages/Meus_Pedidos/Meus_Pedidos';  // Lista Todos Pedidos Efetuados
import Clientes_Faturados from './components/Pages/Faturado/Faturado';  // Clientes Faturados
import Cadastro from './components/Pages/Cadastro/Cadastro';  // Cadastro Usuários
import ExtratosItens from './components/Pages/Extratos/ExtratosItens';  // Extratos Itens Faturados 
import FaturadoLinkDePagamento from './components/Pages/FaturadoLinkDePagamento/FaturadoLinkDePagamento'; // Enviar Link Para Pagamento Faturado 
import Compartilhado from './components/Pages/Compartilhado/Compartilhado';
import LinkPagamento from './components/Pages/LinkPagamento/LinkPagamento';
import Painel from '../src/components/Pages/Logistica/Painel';
import Roteiro from '../src/components/Pages/Logistica/Roteiro';
import Planejamento from '../src/components/Pages/Logistica/Planejamento';  
import EsqueciSenha from '../src/components/Pages/Esqueci_Minha_Senha/Esqueci_Minha_Senha';
import Verificacao from '../src/components/Pages/MinhaConta/verificacao';
import PaginaLinkPagamentoInvalido from './components/Pages/PaginaLinkPagamentoInvalido/PaginaLinkPagamentoInvalido';
import Creditos_Avulsos from './components/Pages/Pagamentos/PagamentoAvulso';
// import DashCadastro from './components/Pages/MinhaContaOLD/DashEndereco';
// import DashCadastro from './components/Pages/MinhaConta/DashCadastro';
// import MinhaConta from './components/Pages/MinhaContaOLD/MinhaConta';

const Routes = (props) => {  
    return (        
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/lojas_fisicas" component={Lojas_Fisicas} />
            <Route path="/frete_gratis" component={Entregas} />
            <Route path="/privacidade" component={Privacidade} />
            <Route path="/produtos" component={() => <Produtos props={props}/>} />
            <Route path="/como_pesquisar_produtos" component={ComoPesquisarProdutos} /> 
            <Route path="/meu_carrinho" component={() => <MeuCarrinho props={props}/> } />
            <Route path="/login" component={Login} />            
            <Route path="/logout" component={Logout} />   

            <Route path="/cadastro" component={() => <Cadastro props={props}/> } />
            {/* 
            <Route path="/cadastro" component={() => <Cadastro props={props}/> } />
            */}
            <Route path="/minha_conta" component={() => <MinhaConta props={props}/> } />
            
            <Route path="/extratos_itens" component={ExtratosItens} />
            <Route path="/compras_faturadas" component={ComprasFaturadas} />
            
            <Route path="/meu_pedido" component={() => <Meu_Pedido props={props}/> } />
            <Route path="/meus_pedidos" component={() => <Meus_Pedidos props={props}/> } />
            <Route path="/faturado" component={() => <Clientes_Faturados props={props}/> } />    

            <Route path="/faturado_link_pagamento" component={() => <FaturadoLinkDePagamento props={props}/> } />
            <Route path="/compartilhado" component={() => <Compartilhado props={props}/> } />
            <Route path="/avista_link_pagamento" component={() => <LinkPagamento props={props}/> } />
            <Route path="/link_pagamento_invalido" component={() => <PaginaLinkPagamentoInvalido props={props}/> } />
            <Route path="/creditos_avulsos" component={() => <Creditos_Avulsos props={props}/> } />            

            <Route path="/logistica" component={() => <Painel /> } />
            <Route path="/logistica_roteiro" component={() => <Roteiro /> } />
            <Route path="/logistica_planejamento" component={() => <Planejamento /> } />    

            <Route path="/esqueci_minha_senha" component={() => <EsqueciSenha /> } /> 
            <Route path="/verificacao" component={() => <Verificacao /> } /> 

             <Redirect from="*" to="/" />
         </Switch>      
    );
}
export default Routes;